import React from 'react';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import STRING_KEYS from '../../../language/keys';
import style from './style';

type LoginActionType = {
  isSubmitting: boolean,
}

const LoginAction = ({ isSubmitting }: LoginActionType): JSX.Element => {
  const { t: translate } = useTranslation();

  return (
    <>
      <Button
        disabled={ isSubmitting }
        fullWidth
        type={ style.type }
        variant={ style.variant }
        sx={ style.sx }
      >
        {translate(STRING_KEYS.LOGIN_BUTTON)}
      </Button>
    </>
  );
};

export default LoginAction;
